const tradeTypes = {
  BUY: 'BUY',
  SELL: 'SELL',
  UNCHANGED: 'UNCHANGED',
}

export { tradeTypes }
